<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/rhythm/pic01.jpg" alt="איך מצטרפים?" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
						<div class="textbox-tab-mark""></div>

<div id="origamiform" data-origamiformname="form_6040d58da93e8" data-origamiformid="f2d20f3608d98263592b19d8f1bea70e5c2f4865d00985f0338d4dd698d501da17b55c228fb1b13516d3ffde34de5f14bffbd3d1b38ca8b6e9e09258db264e4aapWA+JWCk16sDNBfl/qKQqpy48BT2/lcBhnOnLDHG8Fff5YuYMi7YLdLvcY3zIjNelG8COyrRqsqfkEdiMP8jvXOJuSH7APs0kw+vDdN1omdE6kQDCEnZMdod+4ANdEL" ></div>
						<div class="textbox-text">
							
						</div>
					
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			
		</section>
  </main-layout>
</template>
<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Origami.vue'
   import VLink from '../components/VLink.vue'
  import VueScrollTo from 'vue-scrollto'

/* eslint-disable no-useless-escape */
import postscribe from 'postscribe'

  export default {
  mounted:function(){
    postscribe('#origamiform', '<script src="https://public.origamicloud.ms/web_forms/js"><\/script>')
    postscribe('#origamiform', '<script type="text/javascript"> ORIGAMI_FORMS["form_6040d58da93e8"] = { "fields": { "Lead_First_name" : { "value" : "testing", "hidden" : true }, }, "rtl": "1" };  <\/script>')
  },
    components: {
      MainLayout,VLink
    },
	created () {
		this.texts = {}
	},
	ready:function(){
    },
	data() {
		return {
		}
	},
	watch: {

		
	},
	methods: {
		scrollToFooter(){
			this.$scrollTo(".credits", 0, {})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// RepeatQuestions.vue?ae91b19e